import {
  AutocompleteComponent,
  AutocompleteLoadingModeType,
  IAutocompleteSchema,
  ToastService
} from "maps-angular-components";
import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild,} from "@angular/core";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Carteira} from "../../../carteira/carteira.model";
import {CarteiraService} from "../../../carteira/carteira.service";
import {AssociacaoGrupoCarteiraService} from "../../associacao-grupo-carteira.service";

@Component({
  selector: "selecao-carteira",
  templateUrl: "./selecao-carteira.component.html",
  styleUrls: ["./selecao-carteira.component.scss"],
})
export class SelecaoCarteiraComponent implements OnInit {
  @ViewChild("selecaoCarteiraAutocomplete", {static: false}) carteiraAutocomplete: AutocompleteComponent<Carteira>;

  @Input() form: FormGroup;

  @Output() onCarteiraChange: EventEmitter<Carteira[]> = new EventEmitter<Carteira[]>();

  public carteiraSchema: IAutocompleteSchema<Carteira>;
  carteiras: Carteira[] = [];
  page = 1;
  private carteiraHolder: Carteira;

  constructor(
    public associacaoGrupoCarteiraService: AssociacaoGrupoCarteiraService,
    private readonly messageService: ToastService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly formBuilder: FormBuilder,
    private readonly carteiraService: CarteiraService
  ) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      carteira: new FormControl(),
    });
    this.carteiraSchema = {
      service: this.carteiraService,
      label: "Carteira",
      placeholder: "Nome da carteira",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      endpoint: "nome-ou-cnpj-ativo",
      formGroup: this.form,
      required: true,
      formControlName: "carteira",
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
    };
  }

  adicionarCarteira(value) {
    if (!this.carteiraHolder) {
      return;
    }

    if (this.carteiras.some(value => this.carteiraHolder.id === value.id)) {
      this.messageService.alerta('Carteira já selecionada.');
      return;
    }

    this.associacaoGrupoCarteiraService.addCarteira(this.carteiraHolder, this.carteiras);

    this.carteiraAutocomplete.reset();
    this.carteiraHolder = null;
    this.changeDetectorRef.detectChanges();
    this.onCarteiraChange.emit(this.carteiras);
  }

  remove(carteira: any) {
    this.associacaoGrupoCarteiraService.removerCarteira(carteira, this.carteiras);
    this.onCarteiraChange.emit(this.carteiras);
  }

  receiverPage(e: any) {
    this.page = e;
  }

  getCarteirasPaging() {
    return this.getCarteiras(this.page);
  }

  getCarteiras(page: number) {
    const carteirasModel: Carteira[] = [];
    const start = page * 10 - 10;
    for (let i = start; i < page * 10 && i < this.carteiras.length; i++) {
      carteirasModel.push(this.carteiras[i]);
    }
    return carteirasModel;
  }

  getCarteirasTotalPage() {
    const number = Math.ceil(this.carteiras.length / 10);
    if (number === 0) {
      return 1;
    }
    return number;
  }

  clear() {
    this.carteiraAutocomplete.reset();
    this.carteiras = [];
  }

  carteiraSelecionada(carteira: Carteira) {
    this.carteiraHolder = carteira;
  }
}
